import script from "./MeetingTab.vue?vue&type=script&setup=true&name=MeetingTab&lang=js"
export * from "./MeetingTab.vue?vue&type=script&setup=true&name=MeetingTab&lang=js"

import "./MeetingTab.vue?vue&type=style&index=0&id=2f18875e&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f18875e"]])

export default __exports__